import { EnLocaleService, LocaleService, PtLocaleService } from '../services/locale';

export function localeFactory(locale: string): LocaleService {
    let localeService: LocaleService;
        
    switch (locale) {
        default:
        case 'en':
            localeService = new EnLocaleService();
            break;
        case 'pt': 
            localeService = new PtLocaleService();
            break;
    }

    return localeService;
};
